export default "__VITE_ASSET__DpoBanrE__"